var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.global.selectedAppTab == 6)?_c('div',[_c('active-session-card',{attrs:{"client-portal":_vm.clientPortal}}),_c('client-portal-card'),_c('transaction-card',{attrs:{"client-portal":_vm.clientPortal}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }